exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event-spacer[data-v-4b58a410] {\n  margin-bottom: .75rem;\n}\n", ""]);

// exports
